import { casinoEventEmitter } from "./CasinoChannelHandler";
import { sound } from "@pixi/sound";
import { currentBackgorundMusic, setIsMusicBtnOnGlobal, setIsSoundBtnOnGlobal } from "../config/GlobalVariableConfig";

export class BurgerMenuManager {
    constructor() {
        // Subscribe to events
        casinoEventEmitter.on('enableSound', this.enableSound);
        casinoEventEmitter.on('muteSound', this.muteSound);
        casinoEventEmitter.on('enableMusic', this.enableMusic);
        casinoEventEmitter.on('muteMusic', this.muteMusic);

    }

    private enableSound = () => {
        console.log("Sound enabled");
        sound.unmuteAll();// Set volume to maximum or any other level you desire
        setIsSoundBtnOnGlobal(true);
    };

    private muteSound = () => {
        console.log("Sound muted");
        sound.muteAll();   // Mute the sound
        setIsSoundBtnOnGlobal(false);
    };

    private enableMusic = () => {
        console.log("Music enabled");
        setIsMusicBtnOnGlobal(true);
        if (currentBackgorundMusic) {
            currentBackgorundMusic.muted = false;
            // currentBackgorundMusic.volume = currentBackgorundMusicVolume;
        }
    };

    private muteMusic = () => {
        console.log("Music muted");
        setIsMusicBtnOnGlobal(false);
        if (currentBackgorundMusic) {
            // currentBackgorundMusic.volume = 0;
            currentBackgorundMusic.muted = true;
        }
    };

}



